<template>
  <v-card>
    <v-card-title class="d-flex justify-space-between">
      <div>見合状況一覧</div>
      <div>
        <h5>{{ date }}</h5>
      </div>
    </v-card-title>
    <v-card-text>
      <v-row class="justify-center align-center">
        <v-flex xs1 class="mr-15">
          <v-select v-model="status" :items="statuses" item-text="text" item-value="value" label="状態"></v-select>
        </v-flex>
        <v-flex xs1 class="mr-15">
          <v-select v-model="isPayStatus" :items="isPayStatuses" item-text="text" item-value="value"
            label="入金状況"></v-select>
        </v-flex>
        <v-flex xs1 class="mr-10">
          <v-select v-model="resultsTelStatus" :items="resultsTelStatuses" item-text="text" item-value="value"
            label="結果TEL"></v-select>
        </v-flex>
        <v-btn dark class="info mr-3" @click="getEvents()"> 検索 </v-btn>
        <v-btn dark class="error" @click="resetSearch()"> 絞り込み解除 </v-btn>
      </v-row>
      <h3 style="color: #000000" class="ml-8">{{ dateMonth }}</h3>
      <v-sheet tile height="6vh" class="d-flex align-center mb-3">
        <v-btn icon @click="addDay(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn small class="primary ma-4" @click="setToday"> 当月 </v-btn>
        <v-btn icon @click="addDay(1)">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-container>
          <v-row>
            <v-spacer></v-spacer>
            <v-col lg="2" sm="3" cols="6">
              <v-select v-model="shop_id" :items="shops" :label="labelShop" style="min-width: min-content"
                @change="changeShop"></v-select>
            </v-col>
            <v-col lg="2" sm="3" cols="6">
              <v-select v-model="counselorOfList" :items="counselorForFilter" label="担当CO" item-text="name"
                item-value="id" style="min-width: min-content" @change="getEvents()"></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
      <v-sheet>
        <v-data-table :headers="headers" :items="events" :server-items-length="events.length" :loading="loading"
          hide-default-footer class="elevation-1" hide-default-header>
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th v-for="item in headers" :key="item.value" class="column">
                  <div v-if="item.value == 'name1'">
                    <div class="ml-1">
                      {{ item.text }}
                    </div>
                    <div>(自社会員)</div>
                  </div>
                  <div v-else-if="item.value == 'name2'">
                    <div class="ml-1">
                      {{ item.text }}
                    </div>
                    <div>(ｺﾈｸﾄ会員)</div>
                  </div>
                  <span v-else>{{ item.text }}</span>
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <span :class="{
          'text-red':
            date > item.target_date &&
            (item.status == txtStatusPlan ||
              item.status == txtTentativePlan),
        }">
              {{ item.status }}
            </span>
          </template>
          <template v-slot:[`item.isPay`]="{ item }">
            <span :class="{ 'text-red': item.isPay == textNonPayment }">
              {{ item.isPay }}
            </span>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn light class="info" fab small @click="updateDialog(item.id)">
              更新
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination v-model="currentPage" :length="total" v-if="total > 1" @input="reloadList"></v-pagination>
      </v-sheet>
      <!-- InHouseMatchmaking -->
      <InHouseMatchmaking :date="dateForShift" :boothNos="boothNos" :counselors="counselors" :shop_id="shop_id"
        @refreshListHistory="getEvents()" :showFormInHouseMatching="showFormInHouseMatching"
        @closeFormInHouseMatching="showFormInHouseMatching = false" :historyData="historyData" :hideTitleForm="true"
        :valueKindForForm="valueKindForForm" />
      <!-- ConnectMatchmaking -->
      <ConnectMatchmaking :date="dateForShift" :boothNos="boothNos" :counselors="counselors" :shop_id="shop_id"
        @refreshListHistory="getEvents()" :showFormConnectMatching="showFormConnectMatching"
        @closeFormConnectMatching="showFormConnectMatching = false" :historyData="historyData" :hideTitleForm="true"
        :valueKindForForm="valueKindForForm" />
    </v-card-text>
  </v-card>
</template>

<script>
import ConnectMatchmaking from "@/components/ConnectMatchmaking";
import InHouseMatchmaking from "@/components/InHouseMatchmaking";
import constants from "@/consts/constants.js";
import CUSTOMER from "@/consts/customer.js";
import moment from "moment";

export default {
  title: "Matching Status",
  name: "MatchingStatus",
  components: {
    InHouseMatchmaking,
    ConnectMatchmaking,
  },
  data: function () {
    const statusAll = "all";
    const statusUnknown = 3;
    return {
      headers: [
        {
          text: "見合日",
          value: "target_date",
          align: "start",
          sortable: false,
        },
        { text: "時間", value: "target_time", align: "start", sortable: false },
        { text: "見合種別", value: "kind", align: "start", sortable: false },
        { text: "男性会員", value: "name1", align: "start", sortable: false },
        { text: "女性会員", value: "name2", align: "start", sortable: false },
        { text: "担当CO", value: "counselor", align: "start", sortable: false },
        { text: "状態", value: "status", align: "start", sortable: false },
        { text: "入金状況", value: "isPay", align: "start", sortable: false },
        {
          text: "結果TEL",
          value: "resultsTelStatus",
          align: "start",
          sortable: false,
        },
        { text: "情報入力", value: "action", align: "start", sortable: false },
      ],
      loading: false,
      statuses: [{ text: "全て", value: statusAll, name: "ALL" }].concat(
        CUSTOMER.STATUS_DEFAULT.LIST
      ),
      status: statusAll,
      isPayStatuses: [
        { text: "全て", value: statusAll, name: "ALL" },
        { text: "入金済", value: true, name: "DEPOSITED" },
        { text: "未納", value: false, name: "NON_PAYMENT" },
        { text: "対象外", value: statusUnknown, name: "NOT_APPLICABLE" },
      ],
      isPayStatus: statusAll,
      resultsTelStatuses: [
        { text: "全て", value: statusAll, name: "ALL" },
        { text: "済", value: true, name: "DONE" },
        { text: "未", value: false, name: "NOT_YET" },
      ],
      resultsTelStatus: statusAll,
      CUSTOMER: CUSTOMER,
      moment: moment,
      events: [],
      counselors: [],
      counselorForFilter: [
        {
          id: null,
          name: '全て'
        }
      ],
      counselorOfList: null,
      value: moment().format("yyyy-MM-DD"),
      selectedEvent: {},
      shop_id: 0,
      shops: null,
      month: moment().format("yyyy/MM"),
      statusAll,
      statusUnknown,
      txtStatusPlan: "予定",
      txtTentativePlan: "仮予定",
      textNonPayment: "未納",
      historyData: {
        phone: null,
        target_date: null,
        target_time: null,
        kind: 0,
        counselor_id: null,
        note: "",
        status: 0,
        option: {
          verTel: false,
          isPay: false,
          payVal: 0,
          follTel: false,
          result: 0,
          resTel: false,
          decCO: false,
          letter: false,
          matchRes: 0,
          matchTel: false,
          targets: [],
        },
      },
      boothNos: [],
      showFormInHouseMatching: false,
      showFormConnectMatching: false,
      valueKindForForm: "",
      customer: {},
      histories: [],
      boothNoMasters: [],
      currentPage: 1,
      total: null,
      limit: 100,
      shopIdAdmin: 0,
      labelShop: "",
    };
  },
  computed: {
    dateMonth() {
      return moment(this.value).format("yyyy年MM月");
    },
    date() {
      return moment().format("yyyy/MM/DD");
    },
    dateForShift() {
      return moment().format("yyyy-MM-DD");
    },
  },
  async mounted() {
    await this.getShopId();
    await this.getCO();
    await this.getEvents();
    await this.getListBoothNo();
  },
  // async beforeRouteUpdate(to, from, next) {
  //   this.currentPage = parseInt(to.query.page || 1);
  //   await this.getEvents();
  //   next();
  // },
  methods: {
    getCO() {
      this.$axios
        .get(`/api/v1/user/counselors?shop_id=${this.shop_id}`)
        .then((response) => {
          this.counselorForFilter = [
            {
              id: null,
              name: '全て'
            }
          ],
            this.counselors = response.data.counselors;
          this.counselorForFilter = [...this.counselorForFilter, ...response.data.counselors];
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    async setToday() {
      this.currentPage = 1
      this.value = moment().format("yyyy-MM-DD");
      this.month = moment().format("yyyy/MM");
      await this.getEvents();
    },
    async addDay(val) {
      this.currentPage = 1
      this.value = moment(this.value).add(val, "M").format("yyyy-MM-DD");
      this.month = moment(this.value).format("yyyy/MM");
      await this.getEvents();
    },
    async getShopId() {
      await this.$axios.get(`/api/v1/shop`).then((response) => {
        this.shops = response.data.shops;
      });
      const shop_id = this.$store.state.user.shop_id;
      this.shop_id = shop_id;
      this.labelShop = "選択してください";
      if (this.shop_id != this.shopIdAdmin) {
        this.labelShop = "支店";
      }
    },
    async getEvents() {
      if (this.shop_id == this.shopIdAdmin) {
        this.events = [];
        return;
      }
      let url = `/api/v1/appointments/state?limit=${this.limit}&offset=${this.currentPage}&shop_id=${this.shop_id}&date=${this.month}`;
      if (this.status != this.statusAll) {
        url += `&status=${this.status}`;
      }
      if (this.isPayStatus != this.statusAll) {
        url += `&is_pay=${this.isPayStatus}`;
      }
      if (this.resultsTelStatus != this.statusAll) {
        url += `&result_tel=${this.resultsTelStatus}`;
      }
      if (this.counselorOfList != null) {
        url += `&counselor_id=${this.counselorOfList}`;
      }
      this.loading = true;
      this.$axios
        .get(url)
        .then((response) => {
          this.currentPage = response.data.pagination.offset
            ? response.data.pagination.offset
            : 1;
          this.total = response.data.pagination.totalPage
            ? response.data.pagination.totalPage
            : null;
          this.histories = response.data.histories;
          this.events = response.data.histories.map((history) => {
            return {
              id: history.id,
              target_date: history.target_date,
              target_time: history.target_time,
              kind: history.type == CUSTOMER.TYPE_FORM.IN_HOUSE_MATCH ? '自社見合' : 'コネクト見合',
              name1:
                (history.male_customer.family_name
                  ? history.male_customer.family_name
                  : "") +
                (history.male_customer.given_name
                  ? history.male_customer.given_name
                  : ""),
              name2: history.connect_name
                ? history.connect_name
                : (history.female_customer.family_name
                  ? history.female_customer.family_name
                  : "") +
                (history.female_customer.given_name
                  ? history.female_customer.given_name
                  : ""),
              counselor: history.counselor.name,
              status: CUSTOMER.STATUS_DEFAULT.getText(history.status),
              isPay: this.getTitleIsPay(history),
              resultsTelStatus: history.option.resTel == true ? "済" : "未",
            };
          });
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
      this.loading = false;
    },
    changeShop() {
      this.labelShop = "支店";
      this.getEvents();
      this.getCO();
      this.filterBoothNo();
    },
    resetSearch() {
      this.status = this.statusAll;
      this.isPayStatus = this.statusAll;
      this.resultsTelStatus = this.statusAll;
    },
    updateDialog(id) {
      this.valueKindForForm = "";
      const history = this.histories.find((history) => history.id == id);
      if (!history) return;
      this.historyData = {
        id: id,
        phone: history.male_customer.phone_number
          ? history.male_customer.phone_number.trim()
          : "",
        given_name: history.male_customer.given_name,
        family_name: history.male_customer.family_name,
        gender: history.male_customer.gender,
        customer_id: history.customer_id,
        booth_no_id: history.booth_no_id,
        target_date: history.target_date,
        target_time: history.target_time,
        target_time_end: history.target_time_end,
        kind: history.kind,
        counselor_id: history.counselor_id,
        status: history.status,
        type: history.type,
        note: history.note,
        female_customer: history.female_customer,
        male_customer: history.male_customer,
        connect_flag: history.connect_flag,
        connect_no: history.connect_no,
        connect_name: history.connect_name,
        connect_area: history.connect_area,
        is_online: history.is_online,
        option: Object.assign({}, history.option),
      };
      switch (this.historyData.type) {
        case constants.TYPE_FORM.IN_HOUSE_MATCH:
          this.showFormInHouseMatching = true;
          break;
        case constants.TYPE_FORM.CONNECT_ARRANGEMENT:
          this.showFormConnectMatching = true;
          break;
        default:
          return false;
      }
    },
    async getListBoothNo() {
      await this.$axios
        .get("/api/v1/booth_no")
        .then((response) => {
          this.boothNoMasters = response.data.booth_nos;
          this.boothNos = this.boothNoMasters.filter((item) => {
            return item.shop_id == this.shop_id;
          });
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    async reloadList() {
      this.getEvents()
      scrollTo(0, 0);
    },
    filterBoothNo() {
      this.boothNos = this.boothNoMasters.filter((item) => {
        return item.shop_id == this.shop_id;
      });
    },
    getTitleIsPay(history) {
      let text =
        history.status == CUSTOMER.STATUS_DEFAULT.getValue("不履行")
          ? "対象外"
          : history.option.isPay == true
            ? "入金済"
            : "未納";
      if (history.status == CUSTOMER.STATUS_DEFAULT.getValue("不履行")) {
        if (this.isPayStatus == false) {
          text = "未納";
        }
      }
      return text;
    },
  },
};
</script>
<style scoped>
.text-red {
  color: red;
}
</style>
